import { useState, useEffect } from 'react';
import { getLocalStorageByKey, setLocalStorageByKey } from '../../utils';
// It will only store objects in the localStorage, primitive values are not allowed!
export const useLocalStorage = ({ key, initial, }) => {
    const [value, setValue] = useState(() => getLocalStorageByKey(key, initial));
    useEffect(() => {
        setLocalStorageByKey(key, value);
    }, [key, value]);
    return [value, setValue];
};
//# sourceMappingURL=useLocalStorage.js.map